require('sass/brands/stores.petit-bateau.com/location/default.scss');
require('js/location-script.js');
